import {
  ChatIcon,
  EmojiIcon,
  ideaIcon,
  marketIcon,
  researchIcon,
  shareIcon,
  targetIcon,
  testingIcon,
  thumbIcon,
} from "assets/icons";

const {
  faqImg1,
  faqImg2,
  faqImg3,
  faqImg4,
  faqImg5,
  faqImg6,
  appImg1,
  appImg2,
  appImg3,
  reviewImg1,
  reviewImg2,
  reviewImg3,
  surveyStepImg1,
  surveyStepImg2,
  surveyStepImg3,
  surveyStepImg4,
  FingertipsImg1,
  FingertipsImg2,
  FingertipsImg3,
  FingertipsImg4,
} = require("assets/images");

// export const faqs = [
//   {
//     key: 1,
//     image: faqImg1,
//     title: "How do I manage my subscription plan?",
//     description:
//       "Go to the Subscription section to view and select from various plans (Individual, Business, Enterprise). You can see details like the plan name, validity period, and renewal date. Payments for subscriptions are handled directly through the app.",
//   },
//   {
//     key: 2,
//     image: faqImg2,
//     title: "What is the process for publishing a survey?",
//     description:
//       "Create a survey using templates or custom questions, set participant criteria, define rewards, and choose an expiration date. Pay based on participants and reward, or select 'No Incentive' to skip payment.",
//   },
//   {
//     key: 3,
//     image: faqImg3,
//     title: "How can I track the status of my surveys?",
//     description:
//       "Navigate to the Task Management section to view and filter your surveys by status (published, ongoing, completed). You can also see details like the number of responses and expiration dates.",
//   },
//   {
//     key: 4,
//     image: faqImg4,
//     title: "How do I download survey data for analysis?",
//     description:
//       "In the Survey Analysis section, you can export survey data in CSV and XLSX formats.",
//   },
//   {
//     key: 5,
//     image: faqImg5,
//     title: "Can I choose a language for the app?",
//     description:
//       "Yes, you can select between English and Arabic on the Language Screen.",
//   },
//   {
//     key: 6,
//     image: faqImg6,
//     title: "What should I do if I forget my password?",
//     description:
//       "Click on 'Forgot Password' on the login screen. An OTP will be sent to your registered phone number to reset your password.",
//   },
// ];

export const faqs = [
  {
    key: 1,
    image: faqImg1,
    title: {
      en: "How do I manage my subscription plan?",
      ar: "كيف يمكنني إدارة خطة الاشتراك الخاصة بي؟",
    },
    description: {
      en: "Go to the Subscription section to view and select from various plans (Individual, Business, Enterprise). You can see details like the plan name, validity period, and renewal date. Payments for subscriptions are handled directly through the app.",
      ar: "انتقل إلى قسم الاشتراكات لعرض واختيار من بين خطط مختلفة (فردية، أعمال، مؤسسة). يمكنك رؤية تفاصيل مثل اسم الخطة، فترة الصلاحية، وتاريخ التجديد. تتم معالجة المدفوعات للاشتراكات مباشرة من خلال التطبيق.",
    },
  },
  {
    key: 2,
    image: faqImg2,
    title: {
      en: "What is the process for publishing a survey?",
      ar: "ما هي عملية نشر الاستبيان؟",
    },
    description: {
      en: "Create a survey using templates or custom questions, set participant criteria, define rewards, and choose an expiration date. Pay based on participants and reward, or select 'No Incentive' to skip payment.",
      ar: "أنشئ استبيانًا باستخدام القوالب أو الأسئلة المخصصة، حدد معايير المشاركين، حدد المكافآت، واختر تاريخ انتهاء. قم بالدفع بناءً على عدد المشاركين والمكافأة، أو اختر 'بدون حافز' لتخطي الدفع.",
    },
  },
  {
    key: 3,
    image: faqImg3,
    title: {
      en: "How can I track the status of my surveys?",
      ar: "كيف يمكنني تتبع حالة الاستبيانات الخاصة بي؟",
    },
    description: {
      en: "Navigate to the Task Management section to view and filter your surveys by status (published, ongoing, completed). You can also see details like the number of responses and expiration dates.",
      ar: "انتقل إلى قسم إدارة المهام لعرض وتصفية الاستبيانات حسب الحالة (منشور، جارٍ، مكتمل). يمكنك أيضًا رؤية تفاصيل مثل عدد الردود وتواريخ الانتهاء.",
    },
  },
  {
    key: 4,
    image: faqImg4,
    title: {
      en: "How do I download survey data for analysis?",
      ar: "كيف يمكنني تنزيل بيانات الاستبيان للتحليل؟",
    },
    description: {
      en: "In the Survey Analysis section, you can export survey data in CSV and XLSX formats.",
      ar: "في قسم تحليل الاستبيان، يمكنك تصدير بيانات الاستبيان بصيغ CSV و XLSX.",
    },
  },
  {
    key: 5,
    image: faqImg5,
    title: {
      en: "Can I choose a language for the app?",
      ar: "هل يمكنني اختيار لغة للتطبيق؟",
    },
    description: {
      en: "Yes, you can select between English and Arabic on the Language Screen.",
      ar: "نعم، يمكنك الاختيار بين اللغة الإنجليزية والعربية من شاشة اللغة.",
    },
  },
  {
    key: 6,
    image: faqImg6,
    title: {
      en: "What should I do if I forget my password?",
      ar: "ماذا أفعل إذا نسيت كلمة المرور؟",
    },
    description: {
      en: "Click on 'Forgot Password' on the login screen. An OTP will be sent to your registered phone number to reset your password.",
      ar: "انقر على 'نسيت كلمة المرور' في شاشة تسجيل الدخول. سيتم إرسال رمز تحقق (OTP) إلى رقم هاتفك المسجل لإعادة تعيين كلمة المرور.",
    },
  },
];

export const experienceData = [
  {
    id: 11,
    icon: thumbIcon,
    title: "Quality feedback",
    description:
      "The 'Create Survey' feature allows clients to effortlessly design and deploy surveys",
  },
  {
    id: 12,
    icon: EmojiIcon,
    title: "Real people",
    description:
      "The 'Create Survey' feature allows clients to effortlessly design and deploy surveys",
  },
  {
    id: 13,
    icon: ChatIcon,
    title: "Honest answers",
    description:
      "The 'Create Survey' feature allows clients to effortlessly design and deploy surveys",
  },
  {
    id: 14,
    icon: targetIcon,
    title: "Any target audience",
    description:
      "The 'Create Survey' feature allows clients to effortlessly design and deploy surveys",
  },
  {
    id: 15,
    icon: marketIcon,
    title: "Boost revenue",
    description:
      "The 'Create Survey' feature allows clients to effortlessly design and deploy surveys",
  },
  {
    id: 16,
    icon: testingIcon,
    title: "A/B testing",
    description:
      "The 'Create Survey' feature allows clients to effortlessly design and deploy surveys",
  },
  {
    id: 17,
    icon: ideaIcon,
    title: "Idea validation",
    description:
      "The 'Create Survey' feature allows clients to effortlessly design and deploy surveys",
  },
  {
    id: 18,
    icon: researchIcon,
    title: "Market research",
    description:
      "The 'Create Survey' feature allows clients to effortlessly design and deploy surveys",
  },
];

export const cardsData = [
  {
    key: 21,
    image: appImg1,
    title: "Create An Account",
    description: [
      "Registering with our application allows you to easily set up and manage your surveys with tailored subscription plans that fit your needs.",
      "Enjoy seamless account verification and profile setup, streamlined subscription management, and efficient survey creation with advanced features.",
    ],
  },
  {
    key: 22,
    image: appImg2,
    title: "Create Survey Form",
    description: [
      'The "Create Survey" feature allows clients to effortlessly design and deploy surveys tailored to their needs.',
      "Choose from predefined templates or create custom surveys with a range of question types and advanced features like skip logic and block sections.",
      "Customize your survey with logos and detailed settings, and easily publish it to target specific participant criteria.",
    ],
  },
  {
    key: 23,
    image: appImg3,
    title: "Rewards",
    description: [
      "Our rewards system ensures that every participant is incentivized, which boosts engagement and completion rates.",
      "By setting a reward per participant, clients can attract quality responses while managing costs effectively.",
      "The seamless payment and reward distribution process supports your research goals while maintaining transparency and efficiency.",
    ],
  },
];

export const USER_TYPES = [
  { key: "userType1", label: "Researcher", value: "researcher" },
  { key: "userType2", label: "Participant", value: "participant" },
];

export const USER_EMPLOYEMENT = [
  { key: "employement1", label: "Employed", value: "employed" },
  { key: "employement2", label: "Un-Employed", value: "unemployed" },
];

export const AR_USER_EMPLOYEMENT = [
  { key: "employement1", label: "موظف", value: "employed" },
  { key: "employement2", label: "عاطل عن العمل", value: "unemployed" },
];

export const CMS_TYPES = [
  { key: "cmsType1", label: "About", value: "about" },
  { key: "cmsType2", label: "Terms", value: "terms" },
  { key: "cmsType3", label: "Policy", value: "policy" },
  { key: "cmsType4", label: "Cancel", value: "cancel" },
];

export const MARITAL_STATUSES = [
  { key: "maritalStatus1", label: "Single", value: "single" },
  { key: "maritalStatus2", label: "Married", value: "married" },
  { key: "maritalStatus3", label: "Divorced", value: "divorced" },
  { key: "maritalStatus4", label: "Widowed", value: "widowed" },
];

export const AR_MARITAL_STATUSES = [
  { key: "maritalStatus1", label: "أعزب", value: "single" },
  { key: "maritalStatus2", label: "متزوج", value: "married" },
  { key: "maritalStatus3", label: "مطلق", value: "divorced" },
  { key: "maritalStatus4", label: "أرمل", value: "widowed" },
];

export const EDUCATION_LEVELS = [
  { key: "educationLevel1", label: "Less than High School", value: "lths" },
  { key: "educationLevel2", label: "High School", value: "hs" },
  { key: "educationLevel3", label: "Diploma", value: "diploma" },
  { key: "educationLevel4", label: "Bachelor's Degree", value: "bd" },
  { key: "educationLevel5", label: "Master's Degree", value: "md" },
  { key: "educationLevel6", label: "PhD", value: "phd" },
];

export const AR_EDUCATION_LEVELS = [
  { key: "educationLevel1", label: "أقل من الثانوية", value: "lths" },
  { key: "educationLevel2", label: "ثانوية عامة", value: "hs" },
  { key: "educationLevel3", label: "دبلوم", value: "diploma" },
  { key: "educationLevel4", label: "بكالوريوس", value: "bd" },
  { key: "educationLevel5", label: "ماجستير", value: "md" },
  { key: "educationLevel6", label: "دكتوراه", value: "phd" },
];

export const LIVING_SITUATIONS = [
  { key: "livingSituation1", label: "Renting", value: "renting" },
  { key: "livingSituation2", label: "Own", value: "own" },
  { key: "livingSituation3", label: "Family", value: "family" },
  { key: "livingSituation4", label: "Roommates", value: "roommates" },
];

export const AR_LIVING_SITUATIONS = [
  { key: "livingSituation1", label: "إيجار", value: "renting" },
  { key: "livingSituation2", label: "تملك", value: "own" },
  { key: "livingSituation3", label: "مع العائلة", value: "family" },
  { key: "livingSituation4", label: "مع زملاء سكن", value: "roommates" },
];

export const ANNUAL_INCOMES = [
  { key: "annualIncome1", label: "Less than SAR 5000", value: "lt5000" },
  { key: "annualIncome2", label: "SAR 5000 - SAR 9999", value: "5000-9999" },
  {
    key: "annualIncome3",
    label: "SAR 10000 - SAR 14999",
    value: "10000-14999",
  },
  {
    key: "annualIncome4",
    label: "SAR 15000 - SAR 19999",
    value: "15000-19999",
  },
  {
    key: "annualIncome5",
    label: "SAR 20000 - SAR 29999",
    value: "20000-29999",
  },
  {
    key: "annualIncome6",
    label: "SAR 30000 - SAR 49999",
    value: "30000-49999",
  },
  { key: "annualIncome7", label: "Greater than SAR 50000", value: "gt50000" },
];

export const AR_ANNUAL_INCOMES = [
  { key: "annualIncome1", label: "أقل من 5000 ريال", value: "lt5000" },
  { key: "annualIncome2", label: "5000 - 9999 ريال", value: "5000-9999" },
  { key: "annualIncome3", label: "10000 - 14999 ريال", value: "10000-14999" },
  { key: "annualIncome4", label: "15000 - 19999 ريال", value: "15000-19999" },
  { key: "annualIncome5", label: "20000 - 29999 ريال", value: "20000-29999" },
  { key: "annualIncome6", label: "30000 - 49999 ريال", value: "30000-49999" },
  { key: "annualIncome7", label: "أكثر من 50000 ريال", value: "gt50000" },
];

export const USER_GENDER = [
  { key: "userGender1", label: "Male", value: "male" },
  { key: "userGender2", label: "Female", value: "female" },
];

export const AR_USER_GENDER = [
  { key: "userGender1", label: "ذكر", value: "male" },
  { key: "userGender2", label: "أنثى", value: "female" },
];

export const USER_AGE = [
  { key: "eighteenToTwentyFive", label: "18-25", value: "18-25" },
  { key: "twentySixToThirtyFive", label: "26-35", value: "26-35" },
  { key: "fortySixToFiftyFive", label: "46-55", value: "46-55" },
  { key: "fiftySixToSixtyFive", label: "56-65", value: "56-65" },
  { key: "sixtySixPlus", label: "66+", value: "66+" },
];

export const SURVEY_DURATION = [
  { key: "zeroToFive", label: "0-5 mins", value: "0-5" },
  { key: "fiveToTen", label: "5-10 mins", value: "5-10" },
  { key: "tenToFifteen", label: "10-15 mins", value: "10-15" },
  { key: "fifteenToTwenty", label: "15-20 mins", value: "15-20" },
  { key: "twentyToTwentyFive", label: "20-25 mins", value: "20-25" },
  { key: "twentyFiveToThirty", label: "25-30 mins", value: "25-30" },
  { key: "thirtyToThirtyFive", label: "30-35 mins", value: "30-35" },
  { key: "thirtyFiveToForty", label: "35-40 mins", value: "35-40" },
  { key: "fortyToFortyFive", label: "40-45 mins", value: "40-45" },
  { key: "fortyFiveToFifty", label: "45-50 mins", value: "45-50" },
  { key: "fiftyToFiftyFive", label: "50-55 mins", value: "50-55" },
  { key: "fiftyFiveToSixty", label: "55-60 mins", value: "55-60" },
];

export const AR_SURVEY_DURATION = [
  { key: "zeroToFive", label: "0-5 دقائق", value: "0-5" },
  { key: "fiveToTen", label: "5-10 دقائق", value: "5-10" },
  { key: "tenToFifteen", label: "10-15 دقائق", value: "10-15" },
  { key: "fifteenToTwenty", label: "15-20 دقائق", value: "15-20" },
  { key: "twentyToTwentyFive", label: "20-25 دقائق", value: "20-25" },
  { key: "twentyFiveToThirty", label: "25-30 دقائق", value: "25-30" },
  { key: "thirtyToThirtyFive", label: "30-35 دقائق", value: "30-35" },
  { key: "thirtyFiveToForty", label: "35-40 دقائق", value: "35-40" },
  { key: "fortyToFortyFive", label: "40-45 دقائق", value: "40-45" },
  { key: "fortyFiveToFifty", label: "45-50 دقائق", value: "45-50" },
  { key: "fiftyToFiftyFive", label: "50-55 دقائق", value: "50-55" },
  { key: "fiftyFiveToSixty", label: "55-60 دقائق", value: "55-60" },
];

export const SURVEY_MULTIPLY_CHOICE = [
  { key: "multiple", label: "Multiple Choice Question", value: "multiple" },
  { key: "single", label: "Single Choice Question", value: "single" },
];

export const SURVEY_RANK_ORDER = [
  { key: "tenToTwenty", label: "10-20 mins", value: "10-20" },
  { key: "twentyToThirty", label: "20-30 mins", value: "20-30" },
  { key: "thirtyToForty", label: "30-40 mins", value: "30-40" },
  { key: "fortyToFifty", label: "40-50 mins", value: "40-50" },
  { key: "fiftyToSixty", label: "50-60 mins", value: "50-60" },
];

export const SURVEY_IMAGE_POSITION = [
  { key: "abovethecontent", label: "Above the Content", value: "above" },
  { key: "belowthecontent", label: "Below the Content", value: "below" },
];

// export const SURVEY_RANKING_NUMBER = [
//   { key: "2", label: "2", value: 2 },
//   { key: "4", label: "4", value: 4 },
//   { key: "6", label: "6", value: 6 },
//   { key: "8", label: "8", value: 8 },
// ];

export const OPTION_NUMBER = Array.from({ length: 25 }, (_, index) => {
  const value = index + 1 + 1; // Generate 2, 4, 6, 8
  return { key: value.toString(), label: value.toString(), value };
});

export const RATING_NUMBER = Array.from({ length: 10 }, (_, index) => {
  const value = index;
  return { key: value.toString(), label: value.toString(), value };
});

export const RATING_NUMBER1 = Array.from({ length: 10 }, (_, index) => {
  const value = index + 1;
  return { key: value.toString(), label: value.toString(), value };
});

export const SURVEY_STATUS_LIST = [
  { key: "status", label: "Select Survey Status", value: "" },
  { key: "pending", label: "Pending", value: "draft" },
  { key: "ongoing", label: "Ongoing", value: "ongoing" },
  { key: "completed", label: "Completed", value: "completed" },
];

export const surveyFormValue = {
  MAX_OPTION_LIMIT: 40,
  MIN_TEXT_AREA_LIMIT: 0,
  MAX_TEXT_AREA_LIMIT: 1000,
  OPTION_VALUE_LIMIT: 200,
  MIN_SLIDER_LIMIT: 0,
  MAX_SLIDER_LIMIT: 100,
  SURVEY_BLOCK_LIMIT: 5,
  SURVEY_RANK_COUNT: 4,
  PER_SURVEY_BLOCK_QUESTION_LIMIT: 20,
  SURVEY_IMAGE_POSITION: "below",
  SURVEY_MULTIPLE_OPTION: "multiple",
  STAR_COUNT: 5,
};

export const SURVEY_SLIDER_DATA = {
  MAX_LIMIT: 1000,
  MIN_LIMIT: 0,
  STEP_LIMIT: 100,
  STEP_VALUE: 5,
};

export const extractUserDetail = (data = {}) => {
  const allowedKeys = new Set([
    "firstName",
    "lastName",
    "businessEmail",
    "personalEmail",
    "mobile",
    "dob",
    "region",
    "city",
    "neighbourhoodDistrict",
    "address",
    "gender",
    "martialStatus",
    "educationLevel",
    "employementInfo",
    "annualIncome",
    "currentUserRole",
    "livingSituation",
    "profileUrl",
  ]);

  const transformKey = (key, value) => {
    // Map region, city, neighbourhoodDistrict to their _id if applicable
    return ["region", "city", "neighbourhoodDistrict"].includes(key) &&
      value?._id
      ? value._id
      : value;
  };

  return Object.fromEntries(
    Object.entries(data).reduce((acc, [key, value]) => {
      if (allowedKeys.has(key)) {
        acc.push([key, transformKey(key, value)]);
      }
      return acc;
    }, [])
  );
};

export const generateUniqueId = (blockName) => {
  return `${blockName}-${Date.now().toString(36)}${Math.random().toString(36)}`;
};

export const formatToShortForm = (number) => {
  if (number >= 1_000_000_000) {
    return (number / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B"; // Billion
  }
  if (number >= 1_000_000) {
    return (number / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M"; // Million
  }
  if (number >= 1_000) {
    return (number / 1_000).toFixed(1).replace(/\.0$/, "") + "K"; // Thousand
  }
  return number; // Return the original number if below 1000
};

export const testimonials = [
  {
    img: reviewImg1,
    feedback:
      "I found the survey creation process incredibly user-friendly and efficient. The predefined templates saved me a ton of time, and I appreciated the option to upload a file directly.",
    name: "Anna B",
    role: "Designer",
  },
  {
    img: reviewImg2,
    feedback:
      "The task management and survey analysis features are top-notch. Being able to filter and review submissions easily is a game-changer. Plus, the survey export options in CSV and XLSX formats are perfect for detailed analysis.",
    name: "Mark T.",
    role: "Designer",
  },
  {
    img: reviewImg3,
    feedback:
      "Switching between client & participant roles is smooth, and the survey creation tools are robust. I love how the surveys are, & the subscription plans are clear and flexible. The notifications keep me on track with survey deadlines.",
    name: "Sara L.",
    role: "Designer",
  },
];

export const surveySteps = [
  {
    img: surveyStepImg1,
    title: "Flexible Survey Creation",
    description:
      "Easily design and customize surveys using predefined templates or create new ones from scratch. Add images, rank bar sliders, and apply skip logic to ensure your surveys are tailored to gather the most relevant data.",
  },
  {
    img: surveyStepImg2,
    title: "Comprehensive Survey Analysis",
    description:
      "Analyze survey data through intuitive dashboards and detailed reports. Export data in CSV and XLSX formats, and gain insights with visualizations such as pie charts and bar graphs.",
  },
  {
    img: surveyStepImg3,
    title: "Seamless Payment & Reward Management",
    description:
      "Publish surveys efficiently with transparent payment processes. Manage participant rewards and handle rejected or unfilled surveys with ease, ensuring a smooth and efficient distribution of funds and refunds.",
  },
  {
    img: surveyStepImg4,
    title: "Efficient Task Management",
    description:
      "Easily manage your surveys from creation to completion. Track ongoing and completed surveys, review participant submissions, and extend survey deadlines as needed. Get notified about key events and manage rewards with a streamlined task management system.",
  },
];

export const appDetails = [
  {
    img: appImg1,
    title: "Client Website",
    description:
      "The client website provides a robust platform for managing surveys, analyzing data, and overseeing task performance from a desktop environment.",
    linkText: "Explore Client Website",
  },
  {
    img: appImg2,
    title: "Client App",
    description:
      "The client app offers the flexibility to manage surveys, review submissions, and monitor results from anywhere, using a mobile device.",
    linkText: "Explore Client Mobile App",
  },
  {
    img: appImg3,
    title: "Participants App",
    description:
      "The participant app is optimized for ease of use on mobile devices, making it simple for users to participate in surveys and track their progress.",
    linkText: "Explore Participants Mobile App",
  },
];

export const featureSurveyStepsData = [
  {
    image: FingertipsImg1,
    title: "Flexible Survey Creation",
    description:
      "Easily design and customize surveys using predefined templates or create new ones from scratch. Add images, rank bar sliders,and apply skip logic to ensure your surveys are tailored to gather the most relevant data. Easily design and customize surveys using predefined templates or create new ones from scratch. Add images, rank bar sliders, and apply skip logic to ensure your surveys are tailored to gather the most relevant data.",
  },
  {
    image: FingertipsImg2,
    title: "Comprehensive Survey Analysis",
    description:
      "Analyze survey data through intuitive dashboards and detailed reports. Export data in CSV and XLSX formats, and gain insights with visualizations such as pie charts and bar graphs.Analyze survey data through intuitive dashboards and detailed reports. Export data in CSV and XLSX formats, and gain insights with visualizations such as pie charts and bar graphs.",
  },
  {
    image: FingertipsImg3,
    title: "Seamless Payment & Reward Management",
    description:
      "Publish surveys efficiently with transparent payment processes. Manage participant rewards and handle rejected or unfilled surveys with ease, ensuring a smooth and efficient distribution of funds and refunds.",
  },
  {
    image: FingertipsImg4,
    title: "Efficient Task Management",
    description:
      "Easily manage your surveys from creation to completion. Track ongoing and completed surveys, review participant submissions, and extend survey deadlines as needed. Get notified about key events and manage rewards with a streamlined task management system.",
  },
];

export const featureAppCardsData = [
  {
    image: appImg1,
    title: "Client Website",
    description:
      "The client website provides a robust platform for managing surveys, analyzing data, and overseeing task performance from a desktop environment.",
    linkText: "Explore Client Website",
    link: {
      to: "#",
      icon: shareIcon,
    },
  },
  {
    image: appImg2,
    title: "Client App",
    description:
      "The client app offers the flexibility to manage surveys, review submissions, and monitor results from anywhere, using a mobile device.",
    linkText: "Explore Client Mobile App",
    link: {
      to: "#",
      icon: shareIcon,
    },
  },
  {
    image: appImg3,
    title: "Participants App",
    description:
      "The participant app is optimized for ease of use on mobile devices, making it simple for users to participate in surveys, track their progress.",
    linkText: "Explore Participants Mobile App",
    link: {
      to: "#",
      icon: shareIcon,
    },
  },
];

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const multiLangStaticObject = {
  MULTI_USER_GENDER: {
    en: USER_GENDER,
    ar: AR_USER_GENDER,
  },
  MULTI_EDUCATION_LEVEL: {
    en: EDUCATION_LEVELS,
    ar: AR_EDUCATION_LEVELS,
  },
  MULTI_LIVING_SITUATIONS: {
    en: LIVING_SITUATIONS,
    ar: AR_LIVING_SITUATIONS,
  },
  MULTI_USER_EMPLOYEMENT: {
    en: USER_EMPLOYEMENT,
    ar: AR_USER_EMPLOYEMENT,
  },
  MULTI_MARITAL_STATUSES: {
    en: MARITAL_STATUSES,
    ar: AR_MARITAL_STATUSES,
  },
  MULTI_ANNUAL_INCOMES: {
    en: ANNUAL_INCOMES,
    ar: AR_ANNUAL_INCOMES,
  },
  MULTI_SURVEY_DURATION: {
    en: SURVEY_DURATION,
    ar: AR_SURVEY_DURATION,
  },
};
